/* eslint-disable import/prefer-default-export */
import { css } from 'styled-components';

const DEFAULT_OPACITY = 0.8;
const HOVER_OPACITY = 1;

export const BaseButton = css`
  padding: 0;
  height: 25px;
  width: 25px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #ffffff;
  opacity: ${DEFAULT_OPACITY};

  &:first-child {
    margin-left: 0;
  }

  &:hover {
    opacity: ${HOVER_OPACITY};
  }
`;
